
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'treeMenu',
components: {Swipeout, SwipeoutItem, SwipeoutButton, LoadMore, Flexbox, FlexboxItem, XButton},
data () {
return {
$vue: '',
isTrue: 'lists',
isFalse: '',
isOpen: true, // 暂未用到
collectionList: [], // 收藏病例集合
disabledSwipeOut: false, // 是否不可滑动
isShowLoadMore: false, // 是否显示 loading 图标
loadMoreTip: '点击加载更多', // 提示文字，如果没有显示图标也没有显示文字，则显示点
listNum: '', // 数据总数
isRefreshing: false, // 是否刷新
pageNum: 1, // 第几页参数
pageSize: 10, // 每次加载显示个数
isHasNextPage: true 
}
},
methods: {

deleteCollectionCase (id) {
this.$emit('showDeleteConfirm', {caseId: id})
},

async getCollectionCaseList () {
let params = new URLSearchParams()
params.append('pageSize', this.pageSize.toString())
params.append('pageNum', this.pageNum.toString())
try {
this.$http.post(this.$vue.getData('COLLECTIONCASE_URL'), params).then(suc => {
let data = suc.data.data

this.listNum = data.total

if (this.isRefreshing) {
this.isRefreshing = false
this.collectionList = []
this.$emit('RefreshEvent', {result: '刷新成功'})
}

this.collectionList = this.collectionList.concat(data.list)

this.isHasNextPage = data.hasNextPage
this.$emit('isHasNextPage', {result: this.isHasNextPage})
this.isShowLoadMore = false
if (this.isHasNextPage) {
this.loadMoreTip = '点击加载更多'
} else {
this.loadMoreTip = '没有更多数据了'
}
})
} catch (e) {
console.log(e)
if (this.isRefreshing) {
this.isRefreshing = false
this.$emit('RefreshEvent', {result: '刷新失败'})
}
}
},

loadMore () {

if (this.isHasNextPage) {
this.isShowLoadMore = true
this.loadMoreTip = '正在加载中'
this.pageNum = this.pageNum + 1
this.getCollectionCaseList()
}
},
/**
* @method      clickOn
* @author      dongkuoji
* @description 方法描述: 点击收藏病例
* @date        2018/6/7 14:59
*/
clickOn (caseItem) {
this.$emit('CollectionCaseId', {caseId: caseItem.CASE_ID})
},

refreshList () {

this.pageNum = 1
this.isRefreshing = true

this.getCollectionCaseList()
}
},
beforeMount () {
this.$vue = this
/**
* @author      dongkuoji
* @description 方法描述: 获取收藏病例列表
* @date        2018/5/2 14:46
*/
this.getCollectionCaseList()
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/collection/collectionCaseList/collectionCaseList.vue